/**
 * Load More View for Transaction Collection
 * This is the UI event handler for clicking the Load More link
 */
import Backbone from 'backbone';
import BaseView from 'BaseView';

export default BaseView.extend({
	el: '.js_loadMore-container',

	events: {
		'click .js_loadMore': 'handleLoadMoreTransactions'
	},

	template: 'activity/inc/loadMore',

	initialize () {
		// set load more and next page token flags
		this.model.setLoadMore({
			show: this.$el.data('showLoadMore'),
			nextPageToken: this.$el.data('nextPageToken')
		});

		this.listenTo(this.collection, 'change', this.checkShowLoadMore);
		this.listenTo(this.collection, 'sync', this.checkShowLoadMore);

		this.listenTo(this.model, 'change', this.render);
	},

	checkShowLoadMore (model) {
		/**
		 * TODO: this should just listen for changes to showLoadMore on the ActivityModel
		 * (which is not bound here yet)
		 */
		if (model.collection) {
			if (!model.collection.hasFiltersSet && model.collection.showLoadMore) {
				this.model.setLoadMore({
					show: true,
					nextPageToken: model.collection.nextPageToken
				});
			} else {
				this.model.setLoadMore({
					show: false
				});
			}
		}

		// if no results exist after sync
		if (model.models && model.models.length === 0) {
			this.model.setLoadMore({
				show: false
			});
		}
	},

	/**
	 * Handle event to load more transactions.
	 * Filter View listens to this event and gathers all current search criteria before
	 * triggering a global event for fetching the next set of transactions.
	 *
	 * @param event {Object} - Click event on the 'See more' link (aka "Load more")
	 */
	handleLoadMoreTransactions (event) {
		let nextPageToken = {
			nextPageToken: this.model.get('nextPageToken')
		};

		event.preventDefault();
		Backbone.trigger('activityCollection:loadMoreTransactions', nextPageToken);
	}
});



// WEBPACK FOOTER //
// ./view/activity/loadMoreView.es6